/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon16Regular = forwardRef('ArrowCollapseCHClosedIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.432 9.379a1.95 1.95 0 0 0 0-2.758L3.78 3.969A.75.75 0 1 0 2.72 5.03L5.37 7.682a.45.45 0 0 1 0 .636L2.72 10.969a.75.75 0 1 0 1.06 1.061l2.652-2.651Z" }),
        React.createElement("path", { d: "M9.568 9.379a1.95 1.95 0 0 1 0-2.758l2.652-2.652a.75.75 0 0 1 1.06 1.061L10.63 7.682a.45.45 0 0 0 0 .636l2.651 2.651a.75.75 0 1 1-1.06 1.061L9.568 9.379Z" })));
});
